import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaWallet,
  FaBitcoin,
  FaChevronRight
} from "react-icons/fa";

import "./DepositMobile.css";

export default function MobileMoney() {

  const navigate = useNavigate();

  return (

    <div className="deposit-page">

      {/* Header */}

      <div className="deposit-header">

        <FaArrowLeft
          className="back-icon"
          onClick={() => navigate(-1)}
        />

        <h2>Deposit</h2>

      </div>

      {/* Bottom Sheet */}

      <div className="deposit-sheet">

        <div className="sheet-line"></div>

        {/* Mobile Money */}

        <div
          className="deposit-item"
          onClick={() => navigate("/deposittzmobile")}
        >

          <div className="deposit-left">

            <div className="deposit-icon">

              <FaWallet/>

            </div>

            <div>

              <h3>Deposit Mobile Money</h3>

              <p>
                Deposit instantly using M-Pesa,
                Airtel Money, Tigo Pesa or
                HaloPesa.
              </p>

            </div>

          </div>

          <FaChevronRight className="arrow"/>

        </div>

        {/* Crypto */}

        <div
          className="deposit-item"
          onClick={() => navigate("/crypto-deposit")}
        >

          <div className="deposit-left">

            <div className="deposit-icon">

              <FaBitcoin/>

            </div>

            <div>

              <h3>Crypto</h3>

              <p>
                Transfer crypto from another
                wallet or exchange.
              </p>

            </div>

          </div>

          <FaChevronRight className="arrow"/>

        </div>

      </div>

    </div>

  );

}